import React from 'react';
import { Redirect } from 'react-router-dom';

const Reports = () => {
	return <Redirect to="/client/reports/messages" />
}

export default Reports;